import { useFacilitiesContext } from "@/hooks/useFacilitiesContext";

export const useFacility = (id: number) => {
    const { facilities } = useFacilitiesContext();

    const facility = facilities?.find((facility) => facility.id === id);

    return { facility };
};
